"use strict";

exports.__esModule = true;
exports.BindDataToComponents = void 0;
var _errors = require("../common/errors");
var _config = require("../entities/config");
const BindDataToComponents = ({
  config,
  datasetEvents,
  errorReporter
}) => ({
  dataset,
  connections,
  components
}) => {
  const executeSafely = SafeExecutor({
    errorReporter,
    errorMessage: `Failed executing component's method`
  });
  for (const {
    compId,
    behaviors
  } of connections) {
    // TODO: add behaviors. not all should be bound as onSubmit
    // TODO: add "many" behaviors support
    const [_, behavior] = Object.entries(behaviors).at(0) ?? [];
    if (!behavior) {
      continue;
    }
    const {
      [behavior.type]: eventName
    } = onSubmitTypesToEventName;
    const component = components.find(({
      id
    }) => id === compId);
    if (!_config.Config.isLivePreviewEnabled(config)) {
      datasetEvents.on(dataset, 'dataInitialLoadSuccess', () => executeSafely(component.execute, behavior.hide));
      datasetEvents.on(dataset, 'dataLoadSuccess', () => executeSafely(component.execute, behavior.hide));
      datasetEvents.on(dataset, 'recordSaveAttempt', () => executeSafely(component.execute, behavior.hide));
      datasetEvents.on(dataset, 'recordChange', () => executeSafely(component.execute, behavior.hide));
      datasetEvents.on(dataset, eventName, () => executeSafely(component.execute, behavior.show));
    }
  }
  // const records = await dataStore.getRecords(datasetData.collectionId, { offset: 0, limit: 1 })
  // dataset.set(Dataset.updateListing, { records })
  // if (connections.length) {
  //   for (const connection of connections) {
  //     const boundBehaviors = mapBehaviorsToComponent({ dataset, connection, api: { renderNextRecord, renderPrevRecord } })
  //     const component = components.find((comp: any) => comp.id === connection.compId)!
  //     component.bind(boundBehaviors)
  //   }
  // }
};
exports.BindDataToComponents = BindDataToComponents;
const onSubmitTypesToEventName = {
  success: 'recordSaveSuccess',
  failure: 'recordSaveFailure'
};
const SafeExecutor = ({
  errorReporter,
  errorMessage
}) => (fn, ...args) => {
  try {
    fn(...args);
  } catch (error) {
    errorReporter.report(_errors.CoreError.of(errorMessage, {
      cause: error
    }));
  }
};

// const mapBehaviorsToComponent = ({ dataset, connection, api }: any) => {
//   let behaviorDescriptors = {} as any
//   const { behaviors, properties } = connection
//   for (const [name, connectionDescriptor] of Object.entries<any>(properties)) {
//     if (connectionDescriptor.behaviors) {
//       behaviorDescriptors[name] = mapBehaviorsToComponent({ dataset, connection: connectionDescriptor, api })
//     }
//   }
//   for (const [behaviorName, behavior] of Object.entries(behaviors)) {
//     behaviorDescriptors = { ...behaviorDescriptors, ...behaviorBinders[behaviorName]({ dataset, properties, behavior, api }) }
//   }

//   return behaviorDescriptors
// }

// const behaviorBinders: { [x: string]: any } = {
//   input: ({
//     dataset, properties,
//     behavior: { onChange: onChangeProp, value: valueProp },
//   }: any) => ({
//     [onChangeProp]: (value: any) =>
//       dataset.set(Dataset.updateCurrentRecord, { [properties[valueProp].fieldName]: value }),
//   }),
//   click: (settings: any) => actionHandlers[settings.behavior.action](settings),
// }

// const actionHandlers: { [x: string]: any } = {
//   next: ({
//     behavior: { onClick: onClickProp },
//     api: { renderNextRecord },
//   }: any) => ({ [onClickProp]: () => renderNextRecord() }),
//   previous: ({
//     behavior: { onClick: onClickProp },
//     api: { renderPrevRecord },
//   }: any) => ({ [onClickProp]: () => renderPrevRecord() }),
// }
//# sourceMappingURL=bind-data-to-components.js.map